export default __webpack_public_path__ + "static/media/logo.d4264480.svg";